import React, { useCallback } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';

import { useFetchReporte } from '../../hooks/useFetchReporte';

import Default from '../../contenedores/Default';

import CabeceroReportes from '../../componentes/CabeceroReportes';
import ListaConfiguracion from '../../componentes/ListaConfiguracion';
import Tabla from '../../componentes/Table';

import endpoints, {
  NIVELESINFECCION,
  TABLAS,
} from '../../configuraciones/endpoints';

import { DatePickerTypes } from '../../constantes/datePickerTypes';
import { mapaDependenciasCompacto } from '../../constantes/reportes';

const datosLista = {
  labelProp: 'nombre',
  headerLista: 'Nombre',
  title: 'Reporte de Nematodos',
  data: [
    {
      id: 1,
      nombre: 'Hallazgo de nematodos',
      subTitle: 'Listado por nivel de infección',
    },
  ],
};

const cabeceros = [
  { label: 'SITIO', key: 'sitio', align: 'left' },
  { label: 'INVERNADERO', key: 'invernadero', align: 'left' },
  { label: 'NAVE', key: 'Nave', align: 'left' },
  { label: 'TABLA', key: 'Tabla', align: 'left' },
  { label: 'SURCO', key: 'Surco', align: 'left' },
  { label: 'CUADRANTE', key: 'cuadrante', align: 'left' },
  { label: 'NIVEL DE INFECCIÓN', key: 'infeccion', align: 'left' },
];

const ReporteNematodos = ({ history }) => {
  const { registros } = useSelector((store) => store.listados);
  const { data, formData, buscar, onChange, onDelete } = useFetchReporte(
    {
      tablas: endpoints.base.busqueda(TABLAS),
      surcos: ([_sitios, _invernaderos, _naves, tablas]) =>
        tablas.map(({ surcos = [] }) => surcos).flat(),
      nivelInfecciones: endpoints.base.busqueda(NIVELESINFECCION),
    },
    endpoints.reporteNematodos(),
    { incluirInvernaderos: false },
  );

  const handleTodosSelected = useCallback(() => {
    const { sitios, naves, tablas, surcos, niveles, fecha } = formData;

    const params = {
      sitios,
      naves,
      tablas,
      surcos,
      niveles,
      fecha: moment(fecha).format('W-GGGG'),
    };

    return params;
  }, [formData]);

  const onSubMenuClick = (id) => {
    if (id === 1) {
      history.push(`/reportes/nematodos`);
    }
  };

  return (
    <Default
      mostrarLista={
        <ListaConfiguracion
          datosLista={datosLista}
          onClick={onSubMenuClick}
          initOpcion={0}
        />
      }
    >
      <CabeceroReportes
        data={data}
        formData={formData}
        buscar={buscar}
        onChange={onChange}
        onDelete={onDelete}
        handleTodosSelected={handleTodosSelected}
        selects={{
          sitio: { width: 4, show: true },
          invernaderoNave: { width: 4, show: true },
          tabla: { width: 4, show: true },
          surco: { width: 3, show: true },
          nivelInfeccion: { width: 3, show: true },
          fecha: { width: 3, show: true, type: DatePickerTypes.week },
        }}
        endpoint={endpoints.reporteNematodos()}
        method="POST"
        mapaDependencias={mapaDependenciasCompacto}
      />
      <Tabla
        headers={cabeceros}
        rows={registros.rows.length > 0 ? registros.rows : []}
        count={registros.count}
        showActions={false}
      />
    </Default>
  );
};

export default ReporteNematodos;
